import React from 'react';
import { Redirect } from 'react-router-dom';

const pricingConfig = {
    settings: {
        style: 'layout1',
        layout: {
            config: {
                needUserInfo: true,
                redirectOn401: true,
                footer: {
                    display: true
                }
            }
        }
    },
    routes: [
        {
            path: '/pricing',
            component: React.lazy(() => import('./pricing'))
        },
        {
            path: '/free/pricing',
            component: () => <Redirect to={'/pricing'} />
        }
    ]
};
export { pricingConfig };
